"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.cfg = void 0;
const wrappers_1 = require("quasar/wrappers");
const cfg_1 = __importDefault(require("../components/core/cfg"));
exports.cfg = cfg_1.default;
exports.default = wrappers_1.boot(({ app }) => {
    cfg_1.default.init();
    // composition/Options API
    app.provide('$cfg', cfg_1.default);
    // options API
    app.config.globalProperties.$cfg = cfg_1.default;
});
